import { CREATE_RETURN_ERROR, CREATE_RETURN_SUCCESS, CREATE_RETURN_REQUEST } from '../constants/ActionTypes'

export default function returnOrderError(state = false, action) {
    switch (action.type) {
        case CREATE_RETURN_REQUEST:
        case CREATE_RETURN_SUCCESS:
            return false

        case CREATE_RETURN_ERROR:
            return true
        default:
            return state
    }
}
